import { FIVE_MINUTES } from "@/lib/query";
import { useQuery } from "@tanstack/react-query";
import { fetchStoreHeader } from "./api";
import { storeHeaderKey } from "./key";

export function useStoreHeader() {
  return useQuery({
    queryKey: storeHeaderKey.key,
    queryFn: fetchStoreHeader,
    staleTime: FIVE_MINUTES,
  });
}
